module.exports = __webpack_public_path__ + "img/meauicon3.ed411a64.svg";